import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Chips } from "primereact/chips";
import { Dropdown } from "primereact/dropdown";
import { KanbanCardData } from "../types/types";
import { Calendar } from "primereact/calendar";
import { Task } from "../types/types";
import { stripHtmlFromLabel } from "../utils/textFormatting";

interface KanbanCardProps {
  visible: boolean;
  nodeTask: Task;
  setShowKanbanCard: React.Dispatch<React.SetStateAction<boolean>>;
  handleAddUpdateTask: (
    id: string | number,
    title: string,
    nodeTitle: string,
    status: string,
    summary: string,
    priority?: string,
    tags?: string,
    assignee?: string,
    estimate?: number,
    rankId?: number,
    color?: string,
    className?: string,
    startDate?: Date,
    endDate?: Date
  ) => void;
  handleDeleteTask?: (id: string | number) => void;
}

const KanbanCard: React.FC<KanbanCardProps> = ({
  visible,
  nodeTask,
  setShowKanbanCard,
  handleAddUpdateTask,
  handleDeleteTask,
}) => {
  const [id, setId] = useState<string | number>(nodeTask?.id || "");
  const [title, setTitle] = useState<string>(nodeTask?.title || "");
  const [summary, setSummary] = useState<string>(nodeTask?.summary || "");
  const [startDate, setStartDate] = useState<Date | undefined>(
    nodeTask?.startDate ? new Date(nodeTask.startDate) : undefined
  );
  const [endDate, setEndDate] = useState<Date | undefined>(
    nodeTask?.endDate ? new Date(nodeTask.endDate) : undefined
  );
  const [status, setStatus] = useState<string>(nodeTask?.status || "Open");
  const [assignee, setAssignee] = useState<string>(nodeTask?.assignee || "");
  const [tags, setTags] = useState<string>(nodeTask?.tags || "");
  const [priority, setPriority] = useState<string>(nodeTask?.priority || "Low");
  const [estimate, setEstimate] = useState<number | undefined>(
    nodeTask?.estimate
  );
  const [rankId, setRankId] = useState<number | undefined>(nodeTask?.rankId);
  const [color, setColor] = useState<string>(nodeTask?.color || "");
  const [className, setClassName] = useState<string>(nodeTask?.className || "");

  useEffect(() => {
    setId(nodeTask?.id || "");
    setTitle(nodeTask?.title || "");
    setSummary(nodeTask?.summary || "");
    setStartDate(
      nodeTask?.startDate ? new Date(nodeTask.startDate) : undefined
    );
    setEndDate(nodeTask?.endDate ? new Date(nodeTask.endDate) : undefined);
    setStatus(nodeTask?.status || "Open");
    setAssignee(nodeTask?.assignee || "");
    setTags(nodeTask?.tags || "");
    setPriority(nodeTask?.priority || "Low");
    setEstimate(nodeTask?.estimate);
    setRankId(nodeTask?.rankId);
    setColor(nodeTask?.color || "");
    setClassName(nodeTask?.className || "");
  }, [nodeTask, visible]);

  return (
    <Dialog
      visible={visible}
      modal
      header={
        <div>
          <div>Edit Task</div>
          <div style={{ fontSize: "13px", color: "#888", marginTop: "2px" }}>
            {nodeTask?.title
              ? `Title: ${nodeTask.title}`
              : "Enter task details below"}
          </div>
        </div>
      }
      style={{ width: "700px", maxWidth: "90vw" }}
      onHide={() => setShowKanbanCard(false)}
      footer={
        <div>
          {nodeTask?.id && (
            <Button
              label="Delete"
              icon="pi pi-trash"
              className="p-button-danger p-button-text"
              style={{ alignSelf: "flex-start" }}
              onClick={() => {
                handleDeleteTask(id);
              }}
            />
          )}
          <Button
            label="Cancel"
            icon="pi pi-times"
            className="p-button-text"
            onClick={() => setShowKanbanCard(false)}
          />
          <Button
            label="Save"
            icon="pi pi-check"
            className="p-button-primary"
            onClick={() => {
              handleAddUpdateTask(
                id || `task-${Date.now()}`,
                title,
                title,
                status,
                summary,
                priority,
                tags,
                assignee,
                estimate,
                rankId,
                color,
                className,
                startDate,
                endDate
              );
              setShowKanbanCard(false);
            }}
          />
        </div>
      }
    >
      <div
        className="p-fluid"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "1.5rem",
        }}
      >
        <div className="p-col-12">
          <div className="p-field kanban-task-field">
            <label htmlFor="title">Title (edit in map)</label>
            <InputText
              id="title"
              value={stripHtmlFromLabel(title)}
              style={{ fontSize: "16px", backgroundColor: "#f5f5f5" }}
              disabled
            />
          </div>
          <div className="p-field kanban-task-field">
            <label htmlFor="summary">Summary</label>
            <InputTextarea
              id="summary"
              value={summary}
              onChange={(e) => setSummary(e.target.value)}
              rows={6}
              style={{ height: "182px", marginBottom: "5px", fontSize: "16px" }}
            />
          </div>
        </div>
        <div className="p-col-12">
          {/* <div className="p-field kanban-task-field">
            <label htmlFor="status">Status</label>
            <Dropdown
              id="status"
              value={status}
              options={[
                { label: "To Do", value: "Open" },
                { label: "In Progress", value: "InProgress" },
                { label: "Testing", value: "Testing" },
                { label: "Impediment", value: "Impediment" },
                { label: "Done", value: "Done" },
              ]}
              onChange={(e) => setStatus(e.value)}
              placeholder="Select a status"
              style={{
                width: "106%",
                height: "2.45rem",
                minHeight: "unset",
                marginBottom: "16px",
                fontSize: "15px",
              }}
              pt={{
                input: {
                  style: {
                    height: "1.36rem",
                    minHeight: "unset",
                    fontSize: "16px",
                  },
                },
              }}
            />
          </div> */}
          <div className="p-field kanban-task-field">
            <label htmlFor="assignee">Owner</label>
            <InputText
              id="assignee"
              style={{ fontSize: "16px", marginBottom: "10px" }}
              value={assignee}
              onChange={(e) => setAssignee(e.target.value)}
            />
          </div>
          {/* <div className="p-field kanban-task-field">
            <label htmlFor="priority">Priority</label>
            <InputText
              id="priority"
              style={{ fontSize: "16px", marginBottom: "10px" }}
              value={priority}
              onChange={(e) => setPriority(e.target.value)}
            />
          </div> */}
          <div className="p-field kanban-task-field">
            <label htmlFor="estimate">Estimate</label>
            <InputText
              id="estimate"
              type="number"
              style={{ fontSize: "16px", marginBottom: "10px" }}
              value={estimate !== undefined ? String(estimate) : ""}
              onChange={(e) => setEstimate(Number(e.target.value))}
            />
          </div>

          <div className="p-field kanban-task-field">
            <label htmlFor="startDate">Start Date</label>
            <Calendar
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.value as Date | undefined)}
              dateFormat="yy-mm-dd"
              showIcon
              style={{ fontSize: "16px", marginBottom: "10px" }}
              placeholder="Select start date"
            />
          </div>
          <div className="p-field kanban-task-field">
            <label htmlFor="endDate">Due Date</label>
            <Calendar
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.value as Date | undefined)}
              dateFormat="yy-mm-dd"
              showIcon
              style={{ fontSize: "16px", marginBottom: "10px" }}
              placeholder="Select due date"
            />
          </div>
          {/* <div className="p-field kanban-task-field">
            <label htmlFor="tags">Tags</label>
            <Chips
              id="tags"
              style={{ fontSize: "16px", width: "106.5%" }}
              pt={{
                input: { style: { fontSize: "16px" } },
              }}
              value={tags ? nodeTask.tags.split(",") : []}
              onChange={(e) => setTags(e.value.join(","))}
            />
          </div> */}
        </div>
      </div>
    </Dialog>
  );
};

export default KanbanCard;
